import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import {
  ITEM_TYPE_TO_COMPONENT_MAP,
  ITEM_SIZE
} from '#/components/Item/itemHelper';
import { actionClickItem } from '#/services/analytics';
import ContentGrid from '#/components/ContentGrid/ContentGrid';
import useI18n from '#/hooks/useI18n';
import { ITEM_TYPES, ROUTES } from '#/config/constants';

const getCarouselConfig = ({ itemType, config, carouselWidth }) => {
  const width = carouselWidth || 1880; // 1880 to take padding into consideration (1920-40)
  const spacing = 15;
  const itemSize = ITEM_SIZE[itemType];
  const { width: itemWidth, height: itemHeight } = {
    ...itemSize,
    ...config.itemOptions
  };

  return {
    itemHeight,
    itemWidth,
    spacing,
    width
  };
};

const getType = itemType => {
  switch (itemType) {
    case ITEM_TYPES.PortraitBell:
      return ITEM_TYPES.Portrait;
    case ITEM_TYPES.WideBell:
      return ITEM_TYPES.Wide;
    default:
      return itemType;
  }
};

const CarouselShelf = ({
  config = {},
  carouselWidth,
  ds,
  items,
  itemType,
  nav = {},
  onClick,
  template,
  ...props
}) => {
  const { currentLocale = {} } = useI18n();
  const { pathname } = useLocation();
  const { dir } = currentLocale;

  const isHome = pathname === ROUTES.home;
  const Item = ITEM_TYPE_TO_COMPONENT_MAP[itemType];
  const type = getType(itemType);
  const carouselConfig = getCarouselConfig({
    itemType: type,
    config,
    carouselWidth
  });
  const { headPadding = 0, tailPadding = 0 } = config;
  // const useInternalArrows =
  //   items.length * carouselConfig.itemWidth +
  //     items.length * carouselConfig.spacing >=
  //   carouselConfig.width;

  return (
    <ContentGrid
      data={items}
      ds={ds}
      nav={{
        ...nav,
        id: config.id || nav.id,
        useLastFocus: true
      }}
      keyProperty="id"
      itemWidth={carouselConfig.itemWidth}
      itemHeight={carouselConfig.itemHeight}
      horizontal
      headPadding={headPadding}
      tailPadding={tailPadding}
      spacing={carouselConfig.spacing}
      width={carouselConfig.width}
      onClick={item => {
        if (
          template?.includes('crave') ||
          (config.displayText?.toLowerCase() === 'crave' &&
            pathname === ROUTES.home)
        ) {
          return onClick({ link: '/crave' });
        }
        actionClickItem(item.data, config.displayText);
        return onClick(item.data);
      }}
      DisplayComponent={Item}
      displayComponentProps={{ type, specialType: itemType, isHome }}
      initialState={{
        // id: items?.[0]?.id,
        position: headPadding
      }}
      // useInternalArrows={useInternalArrows}
      dir={dir}
      buffer={6}
      {...props}
    />
  );
};

CarouselShelf.propTypes = {
  config: PropTypes.object,
  carouselWidth: PropTypes.number,
  ds: PropTypes.object,
  itemType: PropTypes.string,
  items: PropTypes.array,
  nav: PropTypes.object,
  onClick: PropTypes.func,
  template: PropTypes.string
};

export default CarouselShelf;
